
import './style.scss';
import { registerBlockType } from '@wordpress/blocks';
import Edit, { compressPDFIcon } from './edit';
import metadata from './block.json';

registerBlockType(metadata, {
	icon: compressPDFIcon,
	edit: Edit,
});
